module.exports = __webpack_public_path__ + "static/media/300_6.9c2bbb1d.jpg";